import {useUtils} from "../hooks/utils";
import parse from 'html-react-parser';
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {Modal} from "antd";
import {useContext, useState} from "react";
import {ApiConsumer} from "../api/ApiConsumer";
import {API_URLS, buildFileDownloadUrl} from "../config";
import {ApploadContext} from "../contexts/Appload";
import {useNotification} from "../hooks/NotificationHook";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons";

export const Row = ({application}) => {
    const [shortlist, setShortlist] = useState(false)
    const [reject, setReject] = useState(false)
    let {convertDateToString, convertTimeToString} = useUtils()
    let {setLoading} = useContext(ApploadContext)
    let {SuccessMsg, ErrorMsg} = useNotification();
    const cvPreview = application?.cv_text ? `${application.cv_text.substring(0, 280)}${application.cv_text.length > 280 ? '...' : ''}` : null
    const normalizedStatus = normalizeStatusValue(application.status)

    function normalizeStatusValue(status) {
        const value = (status || '').toUpperCase().replace(/ /g, '_')

        if (value === 'OPEN' || value === 'PENDING') return 'PENDING'
        if (value === 'SHORT_LIST' || value === 'SHORT_LISTED' || value === 'SHORTLISTED') return 'SHORTLISTED'
        if (value === 'INTERVIEWED') return 'INTERVIEWED'
        if (value === 'HIRED') return 'HIRED'
        if (value === 'REJECTED') return 'REJECTED'

        return 'PENDING'
    }

    function ShortlistApplication() {
        setLoading(true)
        ApiConsumer.put(API_URLS.APPLICATIONS.DETAIL(application.id), {status: 'SHORTLISTED'})
            .then(() => {
                SuccessMsg('Application status updated.')
                window.location.reload()
            })
            .catch(() => ErrorMsg('Could not update application status. Please try again later.'))
            .finally(() => setLoading(false))
    }

    function RejectApplication() {
        setLoading(true)
        ApiConsumer.put(API_URLS.APPLICATIONS.DETAIL(application.id), {status: 'REJECTED'})
            .then(() => {
                SuccessMsg('Application status updated.')
                window.location.reload()
            })
            .catch(() => ErrorMsg('Could not update application status. Please try again later.'))
            .finally(() => setLoading(false))
    }

    return <div key={application.id} className="media m-0">
        <Modal
            title={`Confirm Status Change`}
            visible={shortlist}
            onOk={ShortlistApplication}
            icon={<ExclamationCircleOutlined/>}
            onCancel={() => setShortlist(false)}
            okText="Yes"
            cancelText="Cancel"
        >
            <p>Are you sure you want to shortlist this application?</p>
        </Modal>
        <Modal
            title={`Confirm Status Change`}
            visible={reject}
            onOk={RejectApplication}
            icon={<ExclamationCircleOutlined/>}
            onCancel={() => setReject(false)}
            okText="Yes"
            cancelText="Cancel"
        >
            <p>Are you sure you want to reject this application?</p>
        </Modal>
        <div className="media-body">
            <span className="badge bg-pps-blue mt-2">JOB: {application.job.title}</span>
            <h6 className="media-title">
                <p>{`${application.first_name} ${application.last_name}`}</p>
                <span className="ml-3 text-muted float-right">{convertDateToString(application.created)}</span>
                <span className="ml-3 text-muted float-right">{convertTimeToString(application.created)}</span>
            </h6>
            <div className="mb-2">
                {application?.highest_qualification ? <span className="badge bg-pps-light-blue mr-1">{application.highest_qualification}</span> : null}
                {application?.years_of_experience !== null && application?.years_of_experience !== undefined ?
                    <span className="badge bg-pps-light-blue mr-1">{`${application.years_of_experience} years experience`}</span> : null}
            </div>

            <span>{parse(application.job.description)}</span>
            {cvPreview ? <p className="text-muted mt-2 mb-2"><strong>CV Summary:</strong> {cvPreview}</p> : null}
            <div className="clearfix"/>

            {
                normalizedStatus === 'REJECTED' ? <span className="badge bg-danger mt-2">Rejected</span> :
                    normalizedStatus === 'SHORTLISTED' ? <span className="badge bg-pps-gold mt-2">Shortlisted</span> :
                        normalizedStatus === 'INTERVIEWED' ? <span className="badge bg-primary mt-2">Interviewed</span> :
                            normalizedStatus === 'HIRED' ? <span className="badge bg-success mt-2">Hired</span> :
                                <>
                                    <button onClick={() => setShortlist(!shortlist)}
                                            className="btn btn-sm rounded-round bg-pps-blue btn-lg bg-pps-gold legitRipple mr-1 mt-1"
                                            data-toggle="modal" data-target="#modal-shortlist-application">Shortlist
                                    </button>
                                    <button onClick={() => setReject(!reject)}
                                            className="btn btn-sm rounded-round bg-pps-blue btn-lg bg-danger legitRipple mr-1 mt-1"
                                            data-toggle="modal" data-target="#modal-reject-application">Reject
                                    </button>
                                </>
            }

            <a href={buildFileDownloadUrl(application.cv_file_url)} target='_blank'
               className="btn btn-sm rounded-round bg-pps-blue btn-lg legitRipple mt-1 mr-1 float-right"> <FontAwesomeIcon icon={faFilePdf}/> CV</a>
            {
                application.cover_letter_file_url ?
                    <a href={buildFileDownloadUrl(application.cover_letter_file_url)}
                       target='_blank'
                       className="btn btn-sm rounded-round bg-pps-blue btn-lg legitRipple mt-1 mr-1 float-right"><FontAwesomeIcon icon={faFilePdf}/> Cover
                        Letter</a> : null
            }
        </div>
    </div>
}
